import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { ConfirmationService, MessageService } from 'primeng/api';
import Aura from '@primeuix/themes/aura';
import { provideMarkdown } from 'ngx-markdown';
import { appRoutes } from './app.routes';
import { AxiosClient } from '@gishub/infrastructure';
import { Configuration } from './shared/configuration/configuration';
import { errorInterceptor } from './shared/interceptors/error-interceptor';
import { loggingInterceptor } from './shared/interceptors/logging-interceptor';
import { retryInterceptor } from './shared/interceptors/retry-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const config = inject(Configuration);
      console.log(config);
      AxiosClient.setApiUrl(config);
    }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([errorInterceptor, loggingInterceptor, retryInterceptor])),
    MessageService,
    ConfirmationService,
    provideMarkdown(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark-mode',
        },
      },
    }),
  ],
};